export const ReportStatusSelectors = {
    AuthorAssigned: 0,
    AutoRelease: 1,
    AwaitAuthor: 2,
    AwaitCompliance: 3,
    AwaitFeedback: 4,
    Compliant: 5,
    DrafReport: 6,
    Finished: 7,
    Rejected: 8,
    AwaitFurtherCompliance: 9,
    Cancelled: 10,
    ComplianceAssigned: 11,
    CompliantFrn: 12,
    ExecutionOnly: 13,
    FollowUp: 14,
    GiveFeedback: 15,
    MigrateRecommendations: 16,
    SentToClient: 17,
    IssueReport: 18
};